export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
};

export enum AirAiSkillLevelEnum {
  AiNative = 'AiNative',
  BeginnerUser = 'BeginnerUser',
  NotClassified = 'NotClassified',
  PowerUser = 'PowerUser',
  Skeptic = 'Skeptic',
}

export enum AirInterviewInvitationStatusEnum {
  Cancelled = 'Cancelled',
  ConversationFinished = 'ConversationFinished',
  ConversationStarted = 'ConversationStarted',
  Expired = 'Expired',
  Opened = 'Opened',
  Reminded = 'Reminded',
  Sent = 'Sent',
}

export enum AirSessionCreationPurposeEnum {
  Initial = 'Initial',
  Reattempt = 'Reattempt',
  Retake = 'Retake',
}

export enum AirSessionEndReasonEnum {
  Completeness = 'Completeness',
  FatalError = 'FatalError',
  HarmfulSpeech = 'HarmfulSpeech',
  InterviewEndedByUser = 'InterviewEndedByUser',
  IssueReported = 'IssueReported',
  Pagehide = 'Pagehide',
  TimeLimitReached = 'TimeLimitReached',
  UserFinishedEarlier = 'UserFinishedEarlier',
  UserNotSpeaking = 'UserNotSpeaking',
}

export enum AirSessionMessageRoleEnum {
  Expert = 'Expert',
  Recruiter = 'Recruiter',
}

export enum AirSessionSourceEnum {
  ExternalOffer = 'ExternalOffer',
  Hub = 'Hub',
}

export enum AirSessionStatusEnum {
  Closed = 'Closed',
  ConversationError = 'ConversationError',
  ConversationInProgress = 'ConversationInProgress',
  Created = 'Created',
  Finished = 'Finished',
  PreppingCreationFailed = 'PreppingCreationFailed',
  SetMeetingFlow = 'SetMeetingFlow',
}

export type AppendInterviewGatewayLogsInput = {
  entries: Array<ConversationLogEntryInput>;
  preppingId: Scalars['String']['input'];
};

export type ApplyForPublicOfferInputType = {
  cvFileId: Scalars['String']['input'];
  expertId: Scalars['String']['input'];
  expertName: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  recaptchaAction: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export enum ConfirmPublicOfferApplicationBehaviorEnum {
  DefaultBehavior = 'DefaultBehavior',
  RedirectToAir = 'RedirectToAir',
}

export enum ContractSignedEnum {
  No = 'No',
  Processing = 'Processing',
  Yes = 'Yes',
}

export type ConversationLogEntryInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  level: ConversationLogLevelEnum;
  message: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export enum ConversationLogLevelEnum {
  Error = 'Error',
  Info = 'Info',
  Warn = 'Warn',
}

export enum DifficultyLevelEnum {
  Easy = 'Easy',
  Hard = 'Hard',
  Medium = 'Medium',
}

export enum ExpertAvailabilityEnum {
  Days = 'Days',
  Immediately = 'Immediately',
  Months = 'Months',
}

export enum ExpertAvatarEnum {
  Photo = 'Photo',
  WordCloud = 'WordCloud',
}

export type ExpertAvatarHubInputType = {
  mimeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export enum ExpertBlindFlowStatusEnum {
  Accepted = 'Accepted',
  CiCancelledByClient = 'CICancelledByClient',
  CiCancelledByExpert = 'CICancelledByExpert',
  CiFinished = 'CIFinished',
  CiFinishedSecondStage = 'CIFinishedSecondStage',
  CiFinishedThirdStage = 'CIFinishedThirdStage',
  CiScheduled = 'CIScheduled',
  CiScheduledSecondStage = 'CIScheduledSecondStage',
  CiScheduledThirdStage = 'CIScheduledThirdStage',
  ClientWithdrew = 'ClientWithdrew',
  ExpertWithdrew = 'ExpertWithdrew',
  MeetingsCancelled = 'MeetingsCancelled',
  MeetingsScheduled = 'MeetingsScheduled',
  NoFeedback = 'NoFeedback',
  NotSent = 'NotSent',
  Placement = 'Placement',
  Rejected = 'Rejected',
  RejectedAfterCi = 'RejectedAfterCI',
  RejectedByExpert = 'RejectedByExpert',
  RejectedBySales = 'RejectedBySales',
  RejectedOffer = 'RejectedOffer',
  Sent = 'Sent',
}

export enum ExpertBlindFlowStatusFeedbackEnum {
  AlreadyMetWithClient = 'AlreadyMetWithClient',
  BrokenContact = 'BrokenContact',
  BudgetChanged = 'BudgetChanged',
  CandidatePersonalityMismatch = 'CandidatePersonalityMismatch',
  CandidateRemainsWithCurrentCompany = 'CandidateRemainsWithCurrentCompany',
  ChoosingOtherCandidate = 'ChoosingOtherCandidate',
  ClientMadeBadImpression = 'ClientMadeBadImpression',
  ClientRejected = 'ClientRejected',
  Counteroffer = 'Counteroffer',
  ExpectationsChanged = 'ExpectationsChanged',
  Formalities = 'Formalities',
  LocationMismatch = 'LocationMismatch',
  MissingPolishLanguage = 'MissingPolishLanguage',
  NoInformation = 'NoInformation',
  NoticePeriodMismatch = 'NoticePeriodMismatch',
  OurContract = 'OurContract',
  ProcessedDirectlyOrByAnotherVendor = 'ProcessedDirectlyOrByAnotherVendor',
  ProjectDidNotMeetFinancialExpectations = 'ProjectDidNotMeetFinancialExpectations',
  ProjectDidNotMeetOrganizationalExpectations = 'ProjectDidNotMeetOrganizationalExpectations',
  ProjectDidNotMeetTechnicalExpectations = 'ProjectDidNotMeetTechnicalExpectations',
  ProjectDidNotMeetWorkModeExpectations = 'ProjectDidNotMeetWorkModeExpectations',
  RateMismatch = 'RateMismatch',
  RequirementsChanged = 'RequirementsChanged',
  Selection = 'Selection',
  TechnicallyIncompetentCandidate = 'TechnicallyIncompetentCandidate',
  TooLongRecruitmentProcess = 'TooLongRecruitmentProcess',
}

export enum ExpertBlindPlacementSourceEnum {
  CHub = 'CHub',
  Crm = 'CRM',
  Inhire = 'Inhire',
  InnePolecenia = 'InnePolecenia',
  Jjit = 'JJIT',
  LiJobSlot = 'LIJobSlot',
  LiSearch = 'LISearch',
  LinkedIn = 'LinkedIn',
  Nfj = 'NFJ',
  PolecajIZarabiaj = 'PolecajIZarabiaj',
  PracujPl = 'PracujPl',
  Przejecia = 'Przejecia',
  Przepiecie = 'Przepiecie',
  SprawdzonySpecjalista = 'SprawdzonySpecjalista',
}

export enum ExpertBlindSourceEnum {
  Hub = 'Hub',
  Matcher = 'Matcher',
  PublicOffer = 'PublicOffer',
}

export enum ExpertBlindTypeEnum {
  Attrition = 'Attrition',
  RoleBased = 'RoleBased',
  Standard = 'Standard',
}

export type ExpertCertificateHubInputType = {
  id: Scalars['String']['input'];
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ExpertCertificateInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  englishDescription?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum ExpertCvExtractionJobStatusEnum {
  AnonymizationCompleted = 'AnonymizationCompleted',
  AnonymizationFailed = 'AnonymizationFailed',
  AnonymizationInProgress = 'AnonymizationInProgress',
  Canceled = 'Canceled',
  Created = 'Created',
  ExtractionCompleted = 'ExtractionCompleted',
  ExtractionFailed = 'ExtractionFailed',
  ExtractionInProgress = 'ExtractionInProgress',
}

export enum ExpertCvExtractionJobTriggeredFromEnum {
  ExpertCvReupload = 'ExpertCvReupload',
  Matcher = 'Matcher',
  OrganicOnboarding = 'OrganicOnboarding',
  PublicOffer = 'PublicOffer',
}

export enum ExpertCvLocationEnum {
  Dynamics = 'Dynamics',
  Local = 'Local',
}

export enum ExpertCvSourceEnum {
  Crm = 'CRM',
  External = 'External',
  Hub = 'Hub',
  Matcher = 'Matcher',
}

export enum ExpertDataContextEnum {
  AiExtracted = 'AIExtracted',
  Hub = 'Hub',
  Internal = 'Internal',
}

export type ExpertDataHubInputType = {
  availability?: InputMaybe<ExpertAvailabilityEnum>;
  certificates?: InputMaybe<Array<ExpertCertificateHubInputType>>;
  education?: InputMaybe<Array<ExpertEducationHubInputType>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstLanguageId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isMainRoleExperience?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyFirstLanguage?: InputMaybe<Scalars['Boolean']['input']>;
  isOtherRolesExperience?: InputMaybe<Scalars['Boolean']['input']>;
  isRoleSkillUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  jobPositionId?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<LanguageInputType>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<GoogleLocationObjectInput>;
  manuallyAddedTags?: InputMaybe<Array<ExpertTagWeightInputType>>;
  noticeLength?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rateDesired?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<ExpertTagWeightInputType>>;
  workHistory?: InputMaybe<Array<ExpertWorkHistoryHubInputType>>;
  workType?: InputMaybe<WorkModeEnum>;
};

export enum ExpertDataSourceEnum {
  Crm = 'CRM',
  Hub = 'Hub',
  Prospect = 'Prospect',
}

export type ExpertEducationHubInputType = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fieldOfStudyPL?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  schoolName: Scalars['String']['input'];
};

export enum ExpertHubExtractionStateEnum {
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
}

export enum ExpertHubSourceEnum {
  External = 'External',
  Organic = 'Organic',
}

export enum ExpertIdentitySourceEnum {
  Cognito = 'Cognito',
  Google = 'Google',
  LinkedIn = 'LinkedIn',
}

export type ExpertNotificationConsentsInputType = {
  ApplicationAndMeetings: Scalars['Boolean']['input'];
  News: Scalars['Boolean']['input'];
  OffersAndProfiles: Scalars['Boolean']['input'];
};

export enum ExpertNotificationSortEnum {
  CreatedAtAsc = 'CreatedAtAsc',
  CreatedAtDesc = 'CreatedAtDesc',
  UnviewedFirst = 'UnviewedFirst',
}

export enum ExpertNotificationTypeEnum {
  AirConversationNotFinished = 'AirConversationNotFinished',
  CqScheduled = 'CQScheduled',
  CvExtractionFailed = 'CvExtractionFailed',
  IncompleteProfile = 'IncompleteProfile',
  JobOrderApplicationAirConfirmed = 'JobOrderApplicationAIRConfirmed',
  JobOrderApplicationAcceptedAfterCi = 'JobOrderApplicationAcceptedAfterCI',
  JobOrderApplicationCiFinished = 'JobOrderApplicationCIFinished',
  JobOrderApplicationCiScheduled = 'JobOrderApplicationCIScheduled',
  JobOrderApplicationConfirmed = 'JobOrderApplicationConfirmed',
  JobOrderApplicationCreated = 'JobOrderApplicationCreated',
  JobOrderApplicationExpired = 'JobOrderApplicationExpired',
  JobOrderApplicationMeetingScheduled = 'JobOrderApplicationMeetingScheduled',
  JobOrderApplicationPreferencesStepNotFinished = 'JobOrderApplicationPreferencesStepNotFinished',
  JobOrderApplicationRejected = 'JobOrderApplicationRejected',
  JobOrderApplicationRejectedAfterCi = 'JobOrderApplicationRejectedAfterCI',
  JobOrderApplicationStatusChange = 'JobOrderApplicationStatusChange',
  JobOrderMatched = 'JobOrderMatched',
  PublicOfferApplicationWithExtractionCreated = 'PublicOfferApplicationWithExtractionCreated',
  SavedOfferExpired = 'SavedOfferExpired',
  SavedOfferReminder = 'SavedOfferReminder',
}

export type ExpertTagWeightInputType = {
  tagId: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export type ExpertWorkHistoryHubInputType = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isCurrentJob: Scalars['Boolean']['input'];
  jobPositionId: Scalars['String']['input'];
  mainTechnologyIds: Array<Scalars['String']['input']>;
  tagsIds: Array<Scalars['String']['input']>;
};

export type ExpertWorkHistoryInputType = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  englishDescription?: InputMaybe<Scalars['String']['input']>;
  englishIndustry?: InputMaybe<Scalars['String']['input']>;
  englishJobPositionName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  isCompanyNameSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentJob?: InputMaybe<Scalars['Boolean']['input']>;
  jobPositionId?: InputMaybe<Scalars['String']['input']>;
  jobPositionName?: InputMaybe<Scalars['String']['input']>;
  mainTechnologyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FeedbackScoreEnum {
  MorThanFiveDays = 'MorThanFiveDays',
  OneTwoDays = 'OneTwoDays',
  ThreeFourDays = 'ThreeFourDays',
}

export enum FillRateKpiCommentEnum {
  Deadline = 'Deadline',
  FarmersHunting = 'FarmersHunting',
  Hunting = 'Hunting',
  Other = 'Other',
}

export type GoogleLocationObjectInput = {
  description: Scalars['String']['input'];
  matched_substrings: Array<MatchedSubstringInput>;
  place_id: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  structured_formatting: StructuredFormattingInput;
  terms: Array<TermInput>;
  types: Array<Scalars['String']['input']>;
};

export enum JobOrderAnalysisStatusEnum {
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  InProgress = 'InProgress',
}

export enum JobOrderApplicationAnalysisStatusEnum {
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  InProgress = 'InProgress',
}

export enum JobOrderApplicationCreationMethodEnum {
  ExpertBlind = 'ExpertBlind',
  Hub = 'Hub',
  PublicOffer = 'PublicOffer',
}

export enum JobOrderApplicationFlowEnum {
  Conversation = 'Conversation',
  SetMeeting = 'SetMeeting',
}

export enum JobOrderApplicationProcessStatusEnum {
  Accepted = 'Accepted',
  AcceptedAfterCq = 'AcceptedAfterCQ',
  Applied = 'Applied',
  CiCancelledByClient = 'CICancelledByClient',
  CiCancelledByExpert = 'CICancelledByExpert',
  CiFinished = 'CIFinished',
  CiFinishedSecondStage = 'CIFinishedSecondStage',
  CiFinishedThirdStage = 'CIFinishedThirdStage',
  CiScheduled = 'CIScheduled',
  CiScheduledSecondStage = 'CIScheduledSecondStage',
  CiScheduledThirdStage = 'CIScheduledThirdStage',
  ClientWithdrew = 'ClientWithdrew',
  Created = 'Created',
  ExpertWithdrew = 'ExpertWithdrew',
  MeetingsCancelled = 'MeetingsCancelled',
  MeetingsScheduled = 'MeetingsScheduled',
  NoFeedback = 'NoFeedback',
  NotSent = 'NotSent',
  OfferExpired = 'OfferExpired',
  Placement = 'Placement',
  Rejected = 'Rejected',
  RejectedAfterApplied = 'RejectedAfterApplied',
  RejectedAfterCi = 'RejectedAfterCI',
  RejectedAfterCq = 'RejectedAfterCQ',
  RejectedByExpert = 'RejectedByExpert',
  RejectedBySales = 'RejectedBySales',
  RejectedOffer = 'RejectedOffer',
  ScheduledForCq = 'ScheduledForCQ',
  Sent = 'Sent',
}

export enum JobOrderApplicationInterviewReminderOriginEnum {
  FlowChoice = 'FlowChoice',
  Prepping = 'Prepping',
}

export enum JobOrderApplicationReminderOptionEnum {
  DayAfterTomorrow = 'DayAfterTomorrow',
  In3Hours = 'In3Hours',
  NextWeek = 'NextWeek',
  Other = 'Other',
  Tomorrow = 'Tomorrow',
}

export enum JobOrderApplicationStatusEnum {
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  WaitingForConfirmation = 'WaitingForConfirmation',
}

export enum JobOrderApplicationStatusFeedbackEnum {
  AlreadyMetWithClient = 'AlreadyMetWithClient',
  BetterCandidates = 'BetterCandidates',
  BrokenContact = 'BrokenContact',
  BudgetChanged = 'BudgetChanged',
  CandidateCanceledMeeting = 'CandidateCanceledMeeting',
  CandidatePersonalityMismatch = 'CandidatePersonalityMismatch',
  CandidateRemainsWithCurrentCompany = 'CandidateRemainsWithCurrentCompany',
  CheatingDuringAir = 'CheatingDuringAir',
  ChoosingOtherCandidate = 'ChoosingOtherCandidate',
  ClientMadeBadImpression = 'ClientMadeBadImpression',
  ClientRejected = 'ClientRejected',
  Counteroffer = 'Counteroffer',
  ExpectationsChanged = 'ExpectationsChanged',
  Formalities = 'Formalities',
  IndustryMismatch = 'IndustryMismatch',
  LocationMismatch = 'LocationMismatch',
  MissingPolishLanguage = 'MissingPolishLanguage',
  NoInformation = 'NoInformation',
  NoticePeriodMismatch = 'NoticePeriodMismatch',
  OurContract = 'OurContract',
  ProcessedDirectlyOrByAnotherVendor = 'ProcessedDirectlyOrByAnotherVendor',
  ProjectDidNotMeetFinancialExpectations = 'ProjectDidNotMeetFinancialExpectations',
  ProjectDidNotMeetOrganizationalExpectations = 'ProjectDidNotMeetOrganizationalExpectations',
  ProjectDidNotMeetTechnicalExpectations = 'ProjectDidNotMeetTechnicalExpectations',
  ProjectDidNotMeetWorkModeExpectations = 'ProjectDidNotMeetWorkModeExpectations',
  RateMismatch = 'RateMismatch',
  RequirementsChanged = 'RequirementsChanged',
  Selection = 'Selection',
  TechnicallyIncompetentCandidate = 'TechnicallyIncompetentCandidate',
  TooLongRecruitmentProcess = 'TooLongRecruitmentProcess',
}

export type JobOrderAssigneesParamsInputType = {
  brm?: InputMaybe<Scalars['String']['input']>;
  talentAdvocates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JobOrderAssignmentHistoryInputType = {
  assignees: Array<JobOrderAssigneesParamsInputType>;
  assignmentDate: Scalars['DateTime']['input'];
  changedById: Scalars['String']['input'];
  isBttlReset: Scalars['Boolean']['input'];
  isReverted: Scalars['Boolean']['input'];
  owner: Scalars['String']['input'];
};

export type JobOrderBusinessOwnerInputType = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export enum JobOrderBusinessStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type JobOrderCustomFillRateInputType = {
  customDeadlineCI?: InputMaybe<Scalars['DateTime']['input']>;
  customDeadlinePTC?: InputMaybe<Scalars['DateTime']['input']>;
  customDeadlinePlacement?: InputMaybe<Scalars['DateTime']['input']>;
  customTargetCI?: InputMaybe<Scalars['Int']['input']>;
  customTargetPTC?: InputMaybe<Scalars['Int']['input']>;
  customTargetPlacement?: InputMaybe<Scalars['Int']['input']>;
};

export type JobOrderCustomFillrateHistoryInputType = {
  changedAt: Scalars['DateTime']['input'];
  changedById?: InputMaybe<Scalars['String']['input']>;
  customDeadlineCI?: InputMaybe<Scalars['DateTime']['input']>;
  customDeadlinePTC?: InputMaybe<Scalars['DateTime']['input']>;
  customDeadlinePlacement?: InputMaybe<Scalars['DateTime']['input']>;
  customTargetCI?: InputMaybe<Scalars['Int']['input']>;
  customTargetPTC?: InputMaybe<Scalars['Int']['input']>;
  customTargetPlacement?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobOrderDefinitionOfReadyStatusEnum {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  SubmittedForEvaluation = 'SubmittedForEvaluation',
  ToFill = 'ToFill',
}

export enum JobOrderResultEnum {
  Lost = 'Lost',
  Winning = 'Winning',
}

export type JobOrderStatusHistoryInputType = {
  changeDate: Scalars['DateTime']['input'];
  changedById: Scalars['String']['input'];
  changedFrom?: InputMaybe<JobOrderStatusMergeEnum>;
  changedTo: JobOrderStatusMergeEnum;
  comments?: InputMaybe<Scalars['String']['input']>;
  isReverted: Scalars['Boolean']['input'];
  resultStatus?: InputMaybe<JobOrderResultEnum>;
  statusType: JobOrderStatusTypeEnum;
};

export enum JobOrderStatusMergeEnum {
  Accepted = 'Accepted',
  Active = 'Active',
  Inactive = 'Inactive',
  Rejected = 'Rejected',
  SubmittedForEvaluation = 'SubmittedForEvaluation',
  ToFill = 'ToFill',
}

export enum JobOrderStatusTypeEnum {
  BusinessStatus = 'businessStatus',
  DefinitionOfReadyStatus = 'definitionOfReadyStatus',
}

export enum JobOrderTypeEnum {
  Farming = 'Farming',
  Hunting = 'Hunting',
}

export type LanguageInputType = {
  languageId: Scalars['String']['input'];
  level: LanguageLevelEnum;
};

export enum LanguageLevelEnum {
  Advanced = 'Advanced',
  Elementary = 'Elementary',
  Intermediate = 'Intermediate',
  Native = 'Native',
  None = 'None',
  PreIntermediate = 'PreIntermediate',
  UpperIntermediate = 'UpperIntermediate',
}

export enum LegalConsentTypeEnum {
  Air = 'AIR',
}

export type MainTechnologyInputType = {
  defaultTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagId: Scalars['String']['input'];
};

export enum MatchScoreSourceEnum {
  MatchingAlgo = 'MatchingAlgo',
  Prodigy = 'Prodigy',
}

export type MatchedSubstringInput = {
  length: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum MatchingScoreWeightingStrategyEnum {
  Default = 'Default',
  ExpertBlind = 'ExpertBlind',
  ExpertBlindWithRolesStrategy = 'ExpertBlindWithRolesStrategy',
  ProdigyAiMatchScore = 'ProdigyAIMatchScore',
  RolesIncludedStrategy = 'RolesIncludedStrategy',
}

export enum MaxAvailabilityEnum {
  Asap = 'ASAP',
  Month = 'Month',
  MoreThanTwoMonths = 'MoreThanTwoMonths',
}

export enum OnboardingModeEnum {
  Auto = 'Auto',
  Manual = 'Manual',
}

export enum OtpGenericPurposeType {
  AccountDelete = 'AccountDelete',
  Authorization = 'Authorization',
}

export type PaginationType = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
};

export enum ProfileSourceEnum {
  Crm = 'CRM',
  Hub = 'Hub',
}

export type PublicJobBoardOffersFiltersInputType = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Scalars['String']['input']>;
  rateRangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rateRangeTo?: InputMaybe<Scalars['Int']['input']>;
  seniority?: InputMaybe<Array<SeniorityLevelEnum>>;
  workMode?: InputMaybe<Array<WorkModeEnum>>;
};

export enum PublicOfferContextEnum {
  ConnectisJobBoard = 'ConnectisJobBoard',
  Inhire = 'Inhire',
  JobBoard = 'JobBoard',
  JustJoinIt = 'JustJoinIT',
  LinkedIn = 'LinkedIn',
  Marketing = 'Marketing',
  NoFluffJobs = 'NoFluffJobs',
  Other = 'Other',
  PracujPl = 'PracujPL',
  Process = 'Process',
  Referral = 'Referral',
}

export enum PublicOfferStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted',
  Inactive = 'Inactive',
}

export enum QualityLevelEnum {
  Bad = 'Bad',
  Good = 'Good',
  NoDescription = 'NoDescription',
  VeryGood = 'VeryGood',
}

export enum QuestionerJobStatusEnum {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
}

export enum RankingerJobStatusEnum {
  Completed = 'Completed',
  Failed = 'Failed',
  Requested = 'Requested',
}

export enum RecruitmentProcessLengthEnum {
  MoreThanTwoStages = 'MoreThanTwoStages',
  OneStage = 'OneStage',
  TwoStages = 'TwoStages',
}

export enum RecruitmentTestEnum {
  Assigment = 'Assigment',
  NoTest = 'NoTest',
  Test = 'Test',
}

export type RemindAboutInterviewInputType = {
  applicationId: Scalars['String']['input'];
  customDate?: InputMaybe<Scalars['String']['input']>;
  option: JobOrderApplicationReminderOptionEnum;
  origin?: InputMaybe<JobOrderApplicationInterviewReminderOriginEnum>;
};

export type RemoveMeetingHoursHubInputType = {
  blindId: Scalars['String']['input'];
  cancelledMeetingHours: Array<Scalars['String']['input']>;
};

export enum SeniorityLevelEnum {
  Junior = 'Junior',
  Regular = 'Regular',
  Senior = 'Senior',
}

export type SignExpertCvUploadCredentialsInputHubType = {
  expertId?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  source: ExpertCvSourceEnum;
};

export type SignExpertCvUploadCredentialsWithRecaptchaInputType = {
  expertEmail?: InputMaybe<Scalars['String']['input']>;
  expertId?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  recaptchaAction: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  source: ExpertCvSourceEnum;
};

export type StructuredFormattingInput = {
  main_text: Scalars['String']['input'];
  main_text_matched_substrings: Array<MatchedSubstringInput>;
  secondary_text: Scalars['String']['input'];
  secondary_text_matched_substrings?: InputMaybe<Array<MatchedSubstringInput>>;
};

export enum TagTypeEnum {
  Default = 'Default',
  TechnicalSkill = 'TechnicalSkill',
}

export type TermInput = {
  offset: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UpdateJobOrderApplicationPreferencesInputType = {
  availability: ExpertAvailabilityEnum;
  englishLevel: LanguageLevelEnum;
  experienceYears: Scalars['Int']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  location: Scalars['String']['input'];
  noticeLength: Scalars['Int']['input'];
  rateDesired: Scalars['Int']['input'];
  skillsMustHave?: InputMaybe<Array<ExpertTagWeightInputType>>;
  skillsNiceToHave?: InputMaybe<Array<ExpertTagWeightInputType>>;
  workType: WorkModeEnum;
};

export type UpdateMeetingHoursHubInputType = {
  blindId: Scalars['String']['input'];
  cancelledMeetingHours: Array<Scalars['String']['input']>;
  meetingLength: Scalars['Int']['input'];
  suggestedMeetingHours: Array<Scalars['String']['input']>;
};

export enum UserRole {
  Backoffice = 'Backoffice',
  Delivery = 'Delivery',
  Extractor = 'Extractor',
  Planner = 'Planner',
  Sales = 'Sales',
  Sausage = 'Sausage',
  SuperAdmin = 'SuperAdmin',
  SuperSales = 'SuperSales',
  TagAdmin = 'TagAdmin',
}

export enum WorkHourScopeEnum {
  Diffrent = 'Diffrent',
  Elastic = 'Elastic',
  Standard = 'Standard',
}

export enum WorkMethodologyEnum {
  Agile = 'Agile',
  Ccpm = 'CCPM',
  Cpm = 'CPM',
  Kanban = 'Kanban',
  Lean = 'Lean',
  Other = 'Other',
  Pmbok = 'PMBOK',
  Prince2 = 'Prince2',
  Scrum = 'Scrum',
  SixSigma = 'SixSigma',
  Waterfall = 'Waterfall',
}

export enum WorkModeEnum {
  Hybrid = 'Hybrid',
  Office = 'Office',
  Remote = 'Remote',
}

export enum WorkOrderLengthEnum {
  MoreThanSevenMonths = 'MoreThanSevenMonths',
  UpToSixMonths = 'UpToSixMonths',
  UpToThreeMonths = 'UpToThreeMonths',
}
